import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const PostedJobItem = props => (
  <div className="tc">
    <Link className="f4 fw5 link gray dim" to={`/office/job/${props.id}`}>
      {props.jobTitle}
    </Link>
    <div>
      <p>
        <span className="light-purple">created at:</span>
        <span className="ph3">{props.createdAt}</span>
      </p>
      <p>
        <span className="light-purple">closing date:</span>
        <span className="ph3">{props.closingDate}</span>
      </p>
    </div>
    <div className="flex" style={{ justifyContent: "center" }}>
      <p className="pr2 green">
        Applicants: <span>{props.applicants}</span>
      </p>
    </div>
  </div>
);

PostedJobItem.propType = {
  id: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  applicants: PropTypes.number.isRequired,
  location: PropTypes.string.isRequired,
  closingDate: PropTypes.string.isRequired
};

export default PostedJobItem;



// WEBPACK FOOTER //
// ./src/components/PostedJobItem.js